import OImages from "../shared/OImages"
import FadeIn from "../shared/FadeIn"

const titleClassName =
	"font-minerva-regular text-h5 lg:text-h2 text-center capitalize w-[13.2rem] lg:w-[22.5rem] min-h-[7.5rem] lg:min-h-[8rem] leading-none"

const OSectionWithNoImages = ({
	title,
	customClass,
	insideAmenitiesDetailsPage,
	staticTitle,
}: {
	title: string
	customClass?: string
	insideAmenitiesDetailsPage?: boolean
	/** Skip SplitText animation — reserved title box for CLS (About Us) */
	staticTitle?: boolean
}) => {
	const titleNode = staticTitle ? (
		<h2 className={titleClassName}>{title}</h2>
	) : (
		<FadeIn>
			<h2 className={`f-y ${titleClassName}`}>{title}</h2>
		</FadeIn>
	)

	return (
		<div className={`bg-white ${customClass}`}>
			<div className="flex justify-center w-full px-0 lg:px overflow-hidden">
				<div className="w-[calc(100%+8.75rem)] lg:w-[54%] h-[37rem] lg:h-[54%] flex justify-center relative">
					<OImages svgCustomClass="!w-auto !h-[37rem] lg:!w-full lg:!h-[54%]" />
					{
						insideAmenitiesDetailsPage ? (
						<div className="absolute left-1/2 transform -translate-x-1/2 top-[35%] -translate-y-[35%]">
							<div className="hero-title">{titleNode}</div>
						</div>
						) : 
						(
						<div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
							<div className="hero-title">{titleNode}</div>
						</div>
						)
					}
				</div>
			</div>
		</div>
	)
}

export default OSectionWithNoImages
